module.exports = __webpack_public_path__ + "static/media/briefTwo.9be2052a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/briefTwo.png
// module id = 1738
// module chunks = 0 1